import img_0 from 'src/Animations/Images/vodafone/img_0.svg'
import img_1 from 'src/Animations/Images/img_1.png'
import img_2 from 'src/Animations/Images/img_2.png'
import img_3 from 'src/Animations/Images/img_3.png'
import img_4 from 'src/Animations/Images/img_4.png'
import img_5 from 'src/Animations/Images/img_5.png'
import img_6 from 'src/Animations/Images/img_6.png'

export const animationDataVodafonePortugal = {
  "v": "4.8.0",
  "meta": {
    "g": "LottieFiles AE 3.1.1",
    "a": "",
    "k": "",
    "d": "",
    "tc": ""
  },
  "fr": 29.9700012207031,
  "ip": 0,
  "op": 600.000024438501,
  "w": 1080,
  "h": 1080,
  "nm": "Comp 2",
  "ddd": 0,
  "assets": [
    {
      "id": "image_0",
      "w": 113,
      "h": 113,
      "u": "",
      "p": img_0,
      "e": 1
    },
    {
      "id": "image_1",
      "w": 40,
      "h": 40,
      "u": "",
      "p": img_1,
      "e": 1
    },
    {
      "id": "image_2",
      "w": 125,
      "h": 82,
      "u": "",
      "p": img_2,
      "e": 1
    },
    {
      "id": "image_3",
      "w": 334,
      "h": 229,
      "u": "",
      "p": img_3,
      "e": 1
    },
    {
      "id": "image_4",
      "w": 29,
      "h": 18,
      "u": "",
      "p": img_4,
      "e": 1
    },
    {
      "id": "image_5",
      "w": 78,
      "h": 78,
      "u": "",
      "p": img_5,
      "e": 1
    },
    {
      "id": "image_6",
      "w": 11,
      "h": 11,
      "u": "",
      "p": img_6,
      "e": 1
    },
    {
      "id": "comp_0",
      "layers": [
        {
          "ddd": 0,
          "ind": 1,
          "ty": 2,
          "nm": "Rocket.ai",
          "cl": "ai",
          "refId": "image_0",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [
                560,
                534,
                0
              ],
              "ix": 2,
              "x": "var $bm_rt;\n$bm_rt = wiggle(1, 0.2);"
            },
            "a": {
              "a": 0,
              "k": [
                56.5,
                56.5,
                0
              ],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [
                240,
                240,
                100
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "ip": 0,
          "op": 2308.00009400677,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 2,
          "ty": 2,
          "nm": "fire.ai",
          "cl": "ai",
          "refId": "image_1",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [
                560,
                607.7,
                0
              ],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [
                20,
                0,
                0
              ],
              "ix": 1
            },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": {
                    "x": [
                      0.833,
                      0.833,
                      0.833
                    ],
                    "y": [
                      0.833,
                      0.833,
                      0.833
                    ]
                  },
                  "o": {
                    "x": [
                      0.167,
                      0.167,
                      0.167
                    ],
                    "y": [
                      0.167,
                      0.167,
                      0.167
                    ]
                  },
                  "t": 63,
                  "s": [
                    222,
                    222,
                    100
                  ]
                },
                {
                  "i": {
                    "x": [
                      0.833,
                      0.833,
                      0.833
                    ],
                    "y": [
                      0.833,
                      0.833,
                      0.833
                    ]
                  },
                  "o": {
                    "x": [
                      0.167,
                      0.167,
                      0.167
                    ],
                    "y": [
                      0.167,
                      0.167,
                      0.167
                    ]
                  },
                  "t": 71,
                  "s": [
                    222,
                    278.444,
                    100
                  ]
                },
                {
                  "i": {
                    "x": [
                      0.833,
                      0.833,
                      0.833
                    ],
                    "y": [
                      0.833,
                      0.833,
                      0.833
                    ]
                  },
                  "o": {
                    "x": [
                      0.167,
                      0.167,
                      0.167
                    ],
                    "y": [
                      0.167,
                      0.167,
                      0.167
                    ]
                  },
                  "t": 72,
                  "s": [
                    222,
                    245,
                    100
                  ]
                },
                {
                  "i": {
                    "x": [
                      0.833,
                      0.833,
                      0.833
                    ],
                    "y": [
                      0.833,
                      0.833,
                      0.833
                    ]
                  },
                  "o": {
                    "x": [
                      0.167,
                      0.167,
                      0.167
                    ],
                    "y": [
                      0.167,
                      0.167,
                      0.167
                    ]
                  },
                  "t": 76,
                  "s": [
                    222,
                    222,
                    100
                  ]
                },
                {
                  "t": 101.000004113814,
                  "s": [
                    222,
                    222,
                    100
                  ]
                }
              ],
              "ix": 6,
              "x": "var $bm_rt;\n$bm_rt = loopOut();"
            }
          },
          "ao": 0,
          "ef": [
            {
              "ty": 5,
              "nm": "Bounce: Scale",
              "np": 6,
              "mn": "Pseudo/MDS Bounce Controller",
              "ix": 1,
              "en": 1,
              "ef": [
                {
                  "ty": 0,
                  "nm": "Amplitude",
                  "mn": "Pseudo/MDS Bounce Controller-0001",
                  "ix": 1,
                  "v": {
                    "a": 0,
                    "k": 95,
                    "ix": 1
                  }
                },
                {
                  "ty": 0,
                  "nm": "Gravity",
                  "mn": "Pseudo/MDS Bounce Controller-0002",
                  "ix": 2,
                  "v": {
                    "a": 0,
                    "k": 15,
                    "ix": 2
                  }
                },
                {
                  "ty": 0,
                  "nm": "Max Jumps",
                  "mn": "Pseudo/MDS Bounce Controller-0003",
                  "ix": 3,
                  "v": {
                    "a": 0,
                    "k": 5,
                    "ix": 3
                  }
                },
                {
                  "ty": 7,
                  "nm": "Jump In/Out",
                  "mn": "Pseudo/MDS Bounce Controller-0004",
                  "ix": 4,
                  "v": {
                    "a": 0,
                    "k": 1,
                    "ix": 4
                  }
                }
              ]
            }
          ],
          "ip": 0,
          "op": 2308.00009400677,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 3,
          "ty": 2,
          "nm": "Jupiter.ai",
          "cl": "ai",
          "refId": "image_2",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 290,
                  "s": [
                    462,
                    413,
                    0
                  ],
                  "to": [
                    167.667,
                    185,
                    0
                  ],
                  "ti": [
                    0,
                    0,
                    0
                  ]
                },
                {
                  "t": 345.000014052138,
                  "s": [
                    779.6,
                    761.6,
                    0
                  ]
                }
              ],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [
                62.5,
                41,
                0
              ],
              "ix": 1
            },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": {
                    "x": [
                      0.833,
                      0.833,
                      0.833
                    ],
                    "y": [
                      0.833,
                      0.833,
                      0.833
                    ]
                  },
                  "o": {
                    "x": [
                      0.167,
                      0.167,
                      0.167
                    ],
                    "y": [
                      0.167,
                      0.167,
                      0.167
                    ]
                  },
                  "t": 159,
                  "s": [
                    4,
                    4,
                    100
                  ]
                },
                {
                  "i": {
                    "x": [
                      0.833,
                      0.833,
                      0.833
                    ],
                    "y": [
                      0.833,
                      0.833,
                      0.833
                    ]
                  },
                  "o": {
                    "x": [
                      0.167,
                      0.167,
                      0.167
                    ],
                    "y": [
                      0.167,
                      0.167,
                      0.167
                    ]
                  },
                  "t": 265,
                  "s": [
                    19,
                    19,
                    100
                  ]
                },
                {
                  "t": 351.000014296523,
                  "s": [
                    66,
                    66,
                    100
                  ]
                }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "ip": 0,
          "op": 2308.00009400677,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 4,
          "ty": 2,
          "nm": "smoke.ai",
          "cl": "ai",
          "refId": "image_3",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": {
                    "x": 0.667,
                    "y": 1
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 91,
                  "s": [
                    560,
                    599.7,
                    0
                  ],
                  "to": [
                    0,
                    34.5,
                    0
                  ],
                  "ti": [
                    0,
                    -34.5,
                    0
                  ]
                },
                {
                  "t": 103.000004195276,
                  "s": [
                    560,
                    806.7,
                    0
                  ]
                }
              ],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [
                167,
                -0.09,
                0
              ],
              "ix": 1
            },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": {
                    "x": [
                      0.196,
                      0.196,
                      0.667
                    ],
                    "y": [
                      1,
                      1,
                      1
                    ]
                  },
                  "o": {
                    "x": [
                      0.789,
                      0.789,
                      0.333
                    ],
                    "y": [
                      0,
                      0,
                      0
                    ]
                  },
                  "t": 56,
                  "s": [
                    0,
                    0,
                    100
                  ]
                },
                {
                  "t": 84.0000034213901,
                  "s": [
                    61,
                    61,
                    100
                  ]
                }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "ip": 0,
          "op": 2308.00009400677,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 5,
          "ty": 2,
          "nm": "Cloud.ai",
          "cl": "ai",
          "refId": "image_4",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": {
                    "x": 0.833,
                    "y": 0.833
                  },
                  "o": {
                    "x": 0.167,
                    "y": 0.167
                  },
                  "t": 144,
                  "s": [
                    470,
                    412.38,
                    0
                  ],
                  "to": [
                    0,
                    65.167,
                    0
                  ],
                  "ti": [
                    0,
                    -65.167,
                    0
                  ]
                },
                {
                  "t": 192.00000782032,
                  "s": [
                    470,
                    803.38,
                    0
                  ]
                }
              ],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [
                146.5,
                -38,
                0
              ],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [
                -162,
                162,
                100
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "ip": 0,
          "op": 2308.00009400677,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 6,
          "ty": 2,
          "nm": "Cloud.ai",
          "cl": "ai",
          "refId": "image_4",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": {
                    "x": 0.833,
                    "y": 0.833
                  },
                  "o": {
                    "x": 0.167,
                    "y": 0.167
                  },
                  "t": 119,
                  "s": [
                    470,
                    412.38,
                    0
                  ],
                  "to": [
                    0,
                    65.167,
                    0
                  ],
                  "ti": [
                    0,
                    -65.167,
                    0
                  ]
                },
                {
                  "t": 174.000007087165,
                  "s": [
                    470,
                    803.38,
                    0
                  ]
                }
              ],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [
                14.5,
                9,
                0
              ],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [
                270,
                270,
                100
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "ip": 0,
          "op": 2308.00009400677,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 7,
          "ty": 0,
          "nm": "earth1",
          "refId": "comp_1",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": {
                    "x": 0.833,
                    "y": 0.833
                  },
                  "o": {
                    "x": 0.167,
                    "y": 0.167
                  },
                  "t": 112,
                  "s": [
                    560,
                    542,
                    0
                  ],
                  "to": [
                    0,
                    75.667,
                    0
                  ],
                  "ti": [
                    0,
                    -75.667,
                    0
                  ]
                },
                {
                  "t": 175.000007127896,
                  "s": [
                    560,
                    996,
                    0
                  ]
                }
              ],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [
                540,
                571,
                0
              ],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [
                240,
                240,
                100
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "w": 1080,
          "h": 1080,
          "ip": 0,
          "op": 2308.00009400677,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 8,
          "ty": 2,
          "nm": "moon.ai",
          "cl": "ai",
          "refId": "image_5",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": {
                    "x": 0.833,
                    "y": 0.833
                  },
                  "o": {
                    "x": 0.333,
                    "y": 0
                  },
                  "t": 193,
                  "s": [
                    663,
                    446,
                    0
                  ],
                  "to": [
                    -107,
                    208.93,
                    0
                  ],
                  "ti": [
                    54,
                    -66.263,
                    0
                  ]
                },
                {
                  "t": 243.000009897593,
                  "s": [
                    339,
                    843.58,
                    0
                  ]
                }
              ],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [
                39,
                39,
                0
              ],
              "ix": 1
            },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": {
                    "x": [
                      0.833,
                      0.833,
                      0.833
                    ],
                    "y": [
                      0.833,
                      0.833,
                      0.833
                    ]
                  },
                  "o": {
                    "x": [
                      0.167,
                      0.167,
                      0.167
                    ],
                    "y": [
                      0.167,
                      0.167,
                      0.167
                    ]
                  },
                  "t": 176,
                  "s": [
                    28,
                    28,
                    100
                  ]
                },
                {
                  "t": 228.00000928663,
                  "s": [
                    82,
                    82,
                    100
                  ]
                }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "ip": 0,
          "op": 2308.00009400677,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 9,
          "ty": 0,
          "nm": "earth2",
          "refId": "comp_2",
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                {
                  "i": {
                    "x": [
                      0.833
                    ],
                    "y": [
                      0.833
                    ]
                  },
                  "o": {
                    "x": [
                      0.167
                    ],
                    "y": [
                      0.167
                    ]
                  },
                  "t": 178,
                  "s": [
                    100
                  ]
                },
                {
                  "t": 231.000009408823,
                  "s": [
                    0
                  ]
                }
              ],
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [
                560,
                542,
                0
              ],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [
                540,
                540,
                0
              ],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [
                110,
                110,
                100
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "w": 1080,
          "h": 1080,
          "ip": 0,
          "op": 2308.00009400677,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 10,
          "ty": 0,
          "nm": "stars",
          "refId": "comp_3",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [
                540,
                527.422,
                0
              ],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [
                540,
                540,
                0
              ],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [
                100,
                100,
                100
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "w": 1080,
          "h": 1080,
          "ip": 0,
          "op": 2308.00009400677,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 11,
          "ty": 4,
          "nm": "Shape Layer 1",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [
                564,
                542.55,
                0
              ],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [
                24,
                2.55,
                0
              ],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [
                111,
                111,
                100
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          122.607,
                          0
                        ],
                        [
                          0,
                          -122.607
                        ],
                        [
                          -122.607,
                          0
                        ],
                        [
                          0,
                          122.607
                        ]
                      ],
                      "o": [
                        [
                          -122.607,
                          0
                        ],
                        [
                          0,
                          122.607
                        ],
                        [
                          122.607,
                          0
                        ],
                        [
                          0,
                          -122.607
                        ]
                      ],
                      "v": [
                        [
                          -11,
                          -229
                        ],
                        [
                          -233,
                          -7
                        ],
                        [
                          -11,
                          215
                        ],
                        [
                          211,
                          -7
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [
                      0.345097979377,
                      0.050980003207,
                      0.290195988674,
                      1
                    ],
                    "ix": 3
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 4
                  },
                  "w": {
                    "a": 0,
                    "k": 0,
                    "ix": 5
                  },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [
                      0,
                      0.129411764706,
                      0.411764735802,
                      1
                    ],
                    "ix": 4
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 5
                  },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": {
                    "a": 0,
                    "k": [
                      35,
                      12
                    ],
                    "ix": 2
                  },
                  "a": {
                    "a": 0,
                    "k": [
                      0,
                      0
                    ],
                    "ix": 1
                  },
                  "s": {
                    "a": 0,
                    "k": [
                      100,
                      100
                    ],
                    "ix": 3
                  },
                  "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 6
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 7
                  },
                  "sk": {
                    "a": 0,
                    "k": 0,
                    "ix": 4
                  },
                  "sa": {
                    "a": 0,
                    "k": 0,
                    "ix": 5
                  },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 2308.00009400677,
          "st": 0,
          "bm": 0
        }
      ]
    },
    {
      "id": "comp_1",
      "layers": [
        {
          "ddd": 0,
          "ind": 1,
          "ty": 4,
          "nm": "Shape Layer 2",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [
                540,
                540,
                0
              ],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [
                0,
                0,
                0
              ],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [
                100,
                100,
                100
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          0.5,
                          0
                        ],
                        [
                          -0.5,
                          0
                        ],
                        [
                          -0.5,
                          0
                        ],
                        [
                          0.5,
                          0
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [
                      0.345097979377,
                      0.050980003207,
                      0.290195988674,
                      1
                    ],
                    "ix": 3
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 4
                  },
                  "w": {
                    "a": 0,
                    "k": 0,
                    "ix": 5
                  },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [
                      0.647058823529,
                      0.788235353956,
                      0.886274569642,
                      1
                    ],
                    "ix": 4
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 5
                  },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": {
                    "a": 0,
                    "k": [
                      630.5,
                      -65
                    ],
                    "ix": 2
                  },
                  "a": {
                    "a": 0,
                    "k": [
                      0,
                      0
                    ],
                    "ix": 1
                  },
                  "s": {
                    "a": 0,
                    "k": [
                      100,
                      100
                    ],
                    "ix": 3
                  },
                  "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 6
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 7
                  },
                  "sk": {
                    "a": 0,
                    "k": 0,
                    "ix": 4
                  },
                  "sa": {
                    "a": 0,
                    "k": 0,
                    "ix": 5
                  },
                  "nm": "Transform"
                }
              ],
              "nm": "Rectangle 2",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "o": [
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ],
                        [
                          0,
                          0
                        ]
                      ],
                      "v": [
                        [
                          303.5,
                          -111
                        ],
                        [
                          -303.5,
                          -111
                        ],
                        [
                          -303.5,
                          105
                        ],
                        [
                          303.5,
                          105
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [
                      0.345097979377,
                      0.050980003207,
                      0.290195988674,
                      1
                    ],
                    "ix": 3
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 4
                  },
                  "w": {
                    "a": 0,
                    "k": 0,
                    "ix": 5
                  },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [
                      0.647058823529,
                      0.788235353956,
                      0.886274569642,
                      1
                    ],
                    "ix": 4
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 5
                  },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": {
                    "a": 0,
                    "k": [
                      10.5,
                      175
                    ],
                    "ix": 2
                  },
                  "a": {
                    "a": 0,
                    "k": [
                      0,
                      0
                    ],
                    "ix": 1
                  },
                  "s": {
                    "a": 0,
                    "k": [
                      100,
                      100
                    ],
                    "ix": 3
                  },
                  "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 6
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 7
                  },
                  "sk": {
                    "a": 0,
                    "k": 0,
                    "ix": 4
                  },
                  "sa": {
                    "a": 0,
                    "k": 0,
                    "ix": 5
                  },
                  "nm": "Transform"
                }
              ],
              "nm": "Rectangle 1",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 2308.00009400677,
          "st": 0,
          "bm": 0
        }
      ]
    },
    {
      "id": "comp_2",
      "layers": [
        {
          "ddd": 0,
          "ind": 1,
          "ty": 4,
          "nm": "Shape Layer 1",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [
                540,
                537,
                0
              ],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [
                0,
                0,
                0
              ],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [
                100,
                100,
                100
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [
                          124.54,
                          0
                        ],
                        [
                          0,
                          -124.54
                        ],
                        [
                          -124.54,
                          0
                        ],
                        [
                          0,
                          124.54
                        ]
                      ],
                      "o": [
                        [
                          -124.54,
                          0
                        ],
                        [
                          0,
                          124.54
                        ],
                        [
                          124.54,
                          0
                        ],
                        [
                          0,
                          -124.54
                        ]
                      ],
                      "v": [
                        [
                          0,
                          -225.5
                        ],
                        [
                          -225.5,
                          0
                        ],
                        [
                          0,
                          225.5
                        ],
                        [
                          225.5,
                          0
                        ]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [
                      0.345097979377,
                      0.050980003207,
                      0.290195988674,
                      1
                    ],
                    "ix": 3
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 4
                  },
                  "w": {
                    "a": 0,
                    "k": 0,
                    "ix": 5
                  },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [
                      0.772549079446,
                      0.862745157878,
                      0.925490255917,
                      1
                    ],
                    "ix": 4
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 5
                  },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": {
                    "a": 0,
                    "k": [
                      19.5,
                      3.5
                    ],
                    "ix": 2
                  },
                  "a": {
                    "a": 0,
                    "k": [
                      0,
                      0
                    ],
                    "ix": 1
                  },
                  "s": {
                    "a": 0,
                    "k": [
                      100,
                      100
                    ],
                    "ix": 3
                  },
                  "r": {
                    "a": 0,
                    "k": 0,
                    "ix": 6
                  },
                  "o": {
                    "a": 0,
                    "k": 100,
                    "ix": 7
                  },
                  "sk": {
                    "a": 0,
                    "k": 0,
                    "ix": 4
                  },
                  "sa": {
                    "a": 0,
                    "k": 0,
                    "ix": 5
                  },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 2308.00009400677,
          "st": 0,
          "bm": 0
        }
      ]
    },
    {
      "id": "comp_3",
      "layers": [
        {
          "ddd": 0,
          "ind": 1,
          "ty": 0,
          "nm": "threestar",
          "refId": "comp_4",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 63,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [
                463,
                546,
                0
              ],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [
                540,
                540,
                0
              ],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [
                -100,
                100,
                100
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "w": 1080,
          "h": 1080,
          "ip": 11.0000004480392,
          "op": 2319.00009445481,
          "st": 11.0000004480392,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 2,
          "ty": 0,
          "nm": "threestar",
          "refId": "comp_4",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [
                609,
                450,
                0
              ],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [
                540,
                540,
                0
              ],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [
                -100,
                100,
                100
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "w": 1080,
          "h": 1080,
          "ip": 3.00000012219251,
          "op": 2311.00009412896,
          "st": 3.00000012219251,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 3,
          "ty": 0,
          "nm": "threestar",
          "refId": "comp_4",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [
                523,
                453,
                0
              ],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [
                540,
                540,
                0
              ],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [
                100,
                100,
                100
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "w": 1080,
          "h": 1080,
          "ip": -5.00000020365417,
          "op": 2303.00009380311,
          "st": -5.00000020365417,
          "bm": 0
        }
      ]
    },
    {
      "id": "comp_4",
      "layers": [
        {
          "ddd": 0,
          "ind": 1,
          "ty": 0,
          "nm": "Star.ai Comp 1",
          "cl": "ai",
          "refId": "comp_5",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [
                678,
                432,
                0
              ],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [
                540,
                540,
                0
              ],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [
                62,
                62,
                100
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "w": 1080,
          "h": 1080,
          "ip": 104.000004236007,
          "op": 2407.00009803912,
          "st": 99.0000040323527,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 2,
          "ty": 0,
          "nm": "Star.ai Comp 1",
          "cl": "ai",
          "refId": "comp_5",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [
                377,
                521,
                0
              ],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [
                540,
                540,
                0
              ],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [
                62,
                62,
                100
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "w": 1080,
          "h": 1080,
          "ip": 60.0000024438501,
          "op": 2368.00009645062,
          "st": 60.0000024438501,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 3,
          "ty": 0,
          "nm": "Star.ai Comp 1",
          "cl": "ai",
          "refId": "comp_5",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [
                686,
                521,
                0
              ],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [
                540,
                540,
                0
              ],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [
                62,
                62,
                100
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "w": 1080,
          "h": 1080,
          "ip": 0,
          "op": 2308.00009400677,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 4,
          "ty": 0,
          "nm": "Star.ai Comp 1",
          "cl": "ai",
          "refId": "comp_5",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 0,
              "k": [
                324,
                535,
                0
              ],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [
                540,
                540,
                0
              ],
              "ix": 1
            },
            "s": {
              "a": 0,
              "k": [
                62,
                62,
                100
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "w": 1080,
          "h": 1080,
          "ip": 31.0000012626559,
          "op": 2339.00009526942,
          "st": 31.0000012626559,
          "bm": 0
        }
      ]
    },
    {
      "id": "comp_5",
      "layers": [
        {
          "ddd": 0,
          "ind": 1,
          "ty": 2,
          "nm": "Star.ai",
          "cl": "ai",
          "refId": "image_6",
          "sr": 1,
          "ks": {
            "o": {
              "a": 0,
              "k": 100,
              "ix": 11
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": {
                    "x": 0.833,
                    "y": 0.833
                  },
                  "o": {
                    "x": 0.167,
                    "y": 0.167
                  },
                  "t": 0,
                  "s": [
                    578,
                    347,
                    0
                  ],
                  "to": [
                    0,
                    0,
                    0
                  ],
                  "ti": [
                    0,
                    0,
                    0
                  ]
                },
                {
                  "i": {
                    "x": 0.833,
                    "y": 0.833
                  },
                  "o": {
                    "x": 0.167,
                    "y": 0.167
                  },
                  "t": 11,
                  "s": [
                    578,
                    347,
                    0
                  ],
                  "to": [
                    0,
                    110.833,
                    0
                  ],
                  "ti": [
                    0,
                    0,
                    0
                  ]
                },
                {
                  "i": {
                    "x": 0.833,
                    "y": 0.833
                  },
                  "o": {
                    "x": 0.167,
                    "y": 0.167
                  },
                  "t": 26,
                  "s": [
                    578,
                    1012,
                    0
                  ],
                  "to": [
                    0,
                    0,
                    0
                  ],
                  "ti": [
                    0,
                    110.833,
                    0
                  ]
                },
                {
                  "i": {
                    "x": 0.833,
                    "y": 0.833
                  },
                  "o": {
                    "x": 0.167,
                    "y": 0.167
                  },
                  "t": 27,
                  "s": [
                    578,
                    347,
                    0
                  ],
                  "to": [
                    0,
                    0,
                    0
                  ],
                  "ti": [
                    0,
                    0,
                    0
                  ]
                },
                {
                  "t": 38.0000015477717,
                  "s": [
                    578,
                    347,
                    0
                  ]
                }
              ],
              "ix": 2,
              "x": "var $bm_rt;\n$bm_rt = loopOut();"
            },
            "a": {
              "a": 0,
              "k": [
                5.5,
                5.5,
                0
              ],
              "ix": 1
            },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": {
                    "x": [
                      0.833,
                      0.833,
                      0.833
                    ],
                    "y": [
                      0.833,
                      0.833,
                      0.833
                    ]
                  },
                  "o": {
                    "x": [
                      0.167,
                      0.167,
                      0.167
                    ],
                    "y": [
                      0.167,
                      0.167,
                      0.167
                    ]
                  },
                  "t": 0,
                  "s": [
                    0,
                    0,
                    100
                  ]
                },
                {
                  "i": {
                    "x": [
                      0.833,
                      0.833,
                      0.833
                    ],
                    "y": [
                      0.833,
                      0.833,
                      0.833
                    ]
                  },
                  "o": {
                    "x": [
                      0.167,
                      0.167,
                      0.167
                    ],
                    "y": [
                      0.167,
                      0.167,
                      0.167
                    ]
                  },
                  "t": 11,
                  "s": [
                    50,
                    50,
                    100
                  ]
                },
                {
                  "i": {
                    "x": [
                      0.833,
                      0.833,
                      0.833
                    ],
                    "y": [
                      0.833,
                      0.833,
                      0.833
                    ]
                  },
                  "o": {
                    "x": [
                      0.167,
                      0.167,
                      0.167
                    ],
                    "y": [
                      0.167,
                      0.167,
                      0.167
                    ]
                  },
                  "t": 26,
                  "s": [
                    50,
                    50,
                    100
                  ]
                },
                {
                  "i": {
                    "x": [
                      0.833,
                      0.833,
                      0.833
                    ],
                    "y": [
                      0.833,
                      0.833,
                      0.833
                    ]
                  },
                  "o": {
                    "x": [
                      0.167,
                      0.167,
                      0.167
                    ],
                    "y": [
                      0.167,
                      0.167,
                      0.167
                    ]
                  },
                  "t": 27,
                  "s": [
                    0,
                    0,
                    100
                  ]
                },
                {
                  "t": 38.0000015477717,
                  "s": [
                    0,
                    0,
                    100
                  ]
                }
              ],
              "ix": 6,
              "x": "var $bm_rt;\n$bm_rt = loopOut();"
            }
          },
          "ao": 0,
          "ip": 0,
          "op": 2308.00009400677,
          "st": 0,
          "bm": 0
        }
      ]
    }
  ],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 0,
      "nm": "Comp 1",
      "refId": "comp_0",
      "sr": 1,
      "ks": {
        "o": {
          "a": 0,
          "k": 100,
          "ix": 11
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 10
        },
        "p": {
          "a": 0,
          "k": [
            549,
            567,
            0
          ],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [
            555,
            570,
            0
          ],
          "ix": 1
        },
        "s": {
          "a": 0,
          "k": [
            180,
            180,
            100
          ],
          "ix": 6
        }
      },
      "ao": 0,
      "hasMask": true,
      "masksProperties": [
        {
          "inv": false,
          "mode": "a",
          "pt": {
            "a": 0,
            "k": {
              "i": [
                [
                  119.293,
                  0
                ],
                [
                  0,
                  -119.294
                ],
                [
                  -119.293,
                  0
                ],
                [
                  0,
                  119.294
                ]
              ],
              "o": [
                [
                  -119.293,
                  0
                ],
                [
                  0,
                  119.294
                ],
                [
                  119.293,
                  0
                ],
                [
                  0,
                  -119.294
                ]
              ],
              "v": [
                [
                  562,
                  332
                ],
                [
                  346,
                  548
                ],
                [
                  562,
                  764
                ],
                [
                  778,
                  548
                ]
              ],
              "c": true
            },
            "ix": 1
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 3
          },
          "x": {
            "a": 0,
            "k": 0,
            "ix": 4
          },
          "nm": "Mask 1"
        }
      ],
      "w": 1080,
      "h": 1080,
      "ip": 0,
      "op": 2308.00009400677,
      "st": 0,
      "bm": 0
    }
  ],
  "markers": [

  ]
}